import { addCardButtonStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsAddCardButton";
import { cardListStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsCardList";
import { editCardModalStyles } from "@insite/content-library/Widgets/SavedPayments/SavedPaymentsEditCardModal";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import breakpointMediaQueries from "@insite/mobius/utilities/breakpointMediaQueries";
import { COLORS } from "@tCentro/theme/design";
import { css } from "styled-components";

addCardButtonStyles.addCardButton = { 
    mergeCss:true,
    variant: "primary" 
}

addCardButtonStyles.wrapper = {
        css: css`
            display: flex;
            justify-content: flex-end;
            button[data-test-selector^="popoverOverflowTrigger"]{
                min-width: 100%;
                &:hover {
                    border: none !important;
                    background: none !important;
                }
                &:focus {
                    outline: none !important;
                }
            }
        `,
}

cardListStyles.useAsDefaultButton= {
    mergeCss:true,
    variant: "secondary",
    css: css`
        width: 100%;
        padding: 0 15px;
    `,
}

editCardModalStyles.cancelButton = {
    mergeCss:true,
    variant: "secondary",
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
                css`
                    margin-right: 20px;
                `,
            ])}
    `,
}

editCardModalStyles.saveButton= {
    mergeCss:true,
    css: css`
        ${({ theme }: { theme: BaseTheme }) =>
            breakpointMediaQueries(theme, [
                css`
                    width: 100%;
                `,
                css`
                    width: 100%;
                `,
                null,
                null,
                null,
            ])}
    `,
}

editCardModalStyles.makeDefaultCardCheckbox={
    css:css`
        span[role=checkbox] {
            border: 2px solid #9E9D9E !important;
            border-radius: 0 !important;
        &:focus {
            box-shadow: none !important;
        }
        &[aria-checked=true]{
            background: none !important;
            color: ${COLORS.black} !important;
            border: 2px solid ${COLORS.black} !important;
        }
}
    `,
}

editCardModalStyles.useBillToAddressCheckbox= {
    css:css`
        span[role=checkbox] {
            border: 2px solid #9E9D9E !important;
            border-radius: 0 !important;
        &:focus {
            box-shadow: none !important;
        }
        &[aria-checked=true]{
            background: none !important;
            color: ${COLORS.black} !important;
            border: 2px solid ${COLORS.black} !important;
        }
    }
    `,
}